// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "../reducers";
import { ConnectorConstants } from "@msnews/experiences-redux-contracts";
import { ConnectorNamespaces } from "@msnews/experiences-constants";

/**
 * Action signature to trigger an experience to render
 */
type RenderExperienceSignature = () => void;

/**
 * Action signature to initialize data connector state merge.
 */
type DataConnectorMergeInitSignature = (dataConnectorName: ConnectorNamespaces) => void;

/**
 * Actions that are common to all experiences
 * @class
 */
export class CommonActions {
    /**
     * Definition for an action that can be dispatched to any experience causing it to render
     */
    public static renderExperience: ActionMap<RenderExperienceSignature> = new ActionMap<RenderExperienceSignature>(ConnectorConstants.renderAction);

    /**
     * Definition for an action that initializes shared data connector state on an experience.
     */
    public static dataConnectorMergeInit: ActionMap<DataConnectorMergeInitSignature> = new ActionMap<DataConnectorMergeInitSignature>(ConnectorConstants.dataConnectorMergeInitAction);
}